import {CHARACTER_VOICES, VOICE_TUNING} from './CharacterVoiceController.js';
import {VOICE_CHARACTERS} from '../../static/mod/modSchema.js';

// Menu auditions have their own repetition budget, separate from the next run.
export const SELECTION_VOICE_TIMING = Object.freeze({settle: 120, repeat: 8000, maxLoadAge: 4000});

export class CharacterSelectionVoice {
    constructor(audio, {now = () => performance.now(), schedule = (fn, delay) => setTimeout(fn, delay),
        cancel = timer => clearTimeout(timer)} = {}) {
        this.audio = audio;
        this.now = now;
        this.schedule = schedule;
        this.cancel = cancel;
        this.visible = false;
        this.revision = 0;
        this.skin = null;
        this.timer = null;
        this.loading = false;
        this.handle = null;
        this.lastPlayed = new Map();
    }

    show() { this.visible = true; }

    hide() {
        this.visible = false;
        this.stop();
    }

    stop() {
        this.revision++;
        if (this.timer !== null) this.cancel(this.timer);
        this.timer = null;
        this.loading = false;
        this.handle?.stop();
        this.handle = null;
        this.skin = null;
    }

    select(skin) {
        if (!this.visible) return false;
        if (skin === this.skin && (this.timer !== null || this.loading || this.handle?.playing())) return false;
        this.stop();
        this.skin = skin;
        const slug = VOICE_CHARACTERS[skin]?.slug;
        const selectedAt = this.now();
        if (!slug || !(CHARACTER_VOICES[skin] || this.audio.hasCharacterVoice?.(`${slug}_select_01`)) ||
            selectedAt - (this.lastPlayed.get(skin) ?? -Infinity) < SELECTION_VOICE_TIMING.repeat) return false;
        const revision = this.revision;
        this.timer = this.schedule(async () => {
            this.timer = null;
            this.loading = true;
            try {
                const loaded = await this.audio.preloadSFX(`${slug}_select_01`);
                if (!loaded || !this.visible || revision !== this.revision ||
                    this.now() - selectedAt > SELECTION_VOICE_TIMING.maxLoadAge) return;
                // The picker uses normal menu speed, independent of the last
                // level's speed. Gameplay voices still follow that level speed.
                this.handle = this.audio.playCharacterVoice(`${slug}_select_01`, VOICE_TUNING.volume, true, {gameSpeed: 1});
                if (this.handle) this.lastPlayed.set(skin, this.now());
            } catch {
                // A failed audition must never prevent choosing a character.
            } finally {
                if (revision === this.revision) this.loading = false;
            }
        }, SELECTION_VOICE_TIMING.settle);
        return true;
    }
}
